module.exports = __webpack_public_path__ + "static/media/enterStand.d46d7db1.mp3";